import { render } from "./LoadingArea.vue?vue&type=template&id=43656ca2&bindings={\"isLoading\":\"props\",\"showErrors\":\"props\",\"apiUrl\":\"props\",\"apiParams\":\"props\",\"loadingApi\":\"data\",\"apiErrors\":\"data\",\"loading\":\"options\",\"fetchData\":\"options\"}"
import script from "./LoadingArea.vue?vue&type=script&lang=js"
export * from "./LoadingArea.vue?vue&type=script&lang=js"
script.render = render

export default script